export default __webpack_public_path__ + "svgs/chip-602b6a06.svg";